// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, bool, func, string } from 'prop-types'
import HighlightAll from './HighlightAll'
import CloseSearch from './CloseSearch'

class Header extends React.Component {
  static propTypes = {
    allRowsHighlighted: bool.isRequired,
    allRowsHightlightToggle: func,
    closeModal: func,
    hasResults: bool.isRequired,
    highlightRows: bool,
    highlightedRows: array.isRequired,
    idRoot: string.isRequired,
    label: string.isRequired,
    Menu: func,
    results: array.isRequired,
    sourceForm: string.isRequired,
    triggerSearch: func.isRequired,
  }

  // only update this component if the all highlighted prop changes
  shouldComponentUpdate (np) {
    return (
      // if the highlighted rows are different
      np.highlightedRows !== this.props.highlightedRows ||
      // or if hasResults gets updated
      np.hasResults !== this.props.hasResults
    )
  }

  render () {
    const {
      allRowsHighlighted,
      allRowsHightlightToggle,
      closeModal,
      hasResults,
      highlightRows,
      highlightedRows,
      idRoot,
      label,
      Menu,
      results,
      sourceForm,
      triggerSearch,
    } = this.props

    return (
      <div className={'database-search-header display-flex justify-content-between padding-1 padding-bottom-0'}>
        <h3 id={`${idRoot}-modal-heading`}>{label}</h3>
        <div className={'display-flex'}>
          <HighlightAll
            allRowsHighlighted={allRowsHighlighted}
            allRowsHightlightToggle={allRowsHightlightToggle}
            hasResults={hasResults}
            highlightRows={highlightRows}
            highlightedRows={highlightedRows}
            idRoot={`${idRoot}-highlight-all`} />
          {
            Menu &&
            <Menu
              allRowsHighlighted={allRowsHighlighted}
              highlightedRows={highlightedRows}
              idRoot={idRoot}
              results={results}
              sourceForm={sourceForm}
              triggerSearch={triggerSearch} />
          }
          <CloseSearch
            closeModal={closeModal}
            idRoot={idRoot} />
        </div>
      </div>
    )
  }
}

export default Header
